// src/js/config/ui/confirmSaveModal.js
import { DOMElements } from '../dom.js';
import { escapeHTML } from '../../utils/helpers.js';
import { activateTrap, deactivateTrap } from '../../utils/focusTrap.js';

let currentOnOverwriteCallback, currentOnRenameCallback, currentOnCancelCallback;
let originalTrigger = null; // För att minnas var vi kom ifrån

function hideModal() {
    const { confirmSaveModal } = DOMElements;
    if (confirmSaveModal) {
        deactivateTrap();
        if (originalTrigger) originalTrigger.focus(); // Flytta tillbaka fokus
        confirmSaveModal.classList.remove('is-visible');
        document.body.classList.remove('modal-open');
    }
}

export function showConfirmSaveModal(configName, onOverwrite, onRename, onCancel) {
    const { confirmSaveModal, confirmSaveMessage, confirmCancelBtn } = DOMElements;
    if (!confirmSaveModal) return;

    // Spara en referens till elementet som anropade funktionen (troligtvis en knapp)
    originalTrigger = document.activeElement;
    
    const message = (window.SimP_Strings?.save_confirm_overwrite_prompt || "Namnet '%s' finns redan.").replace('%s', escapeHTML(configName));
    if (confirmSaveMessage) confirmSaveMessage.innerHTML = message;
    
    currentOnOverwriteCallback = onOverwrite;
    currentOnRenameCallback = onRename;
    currentOnCancelCallback = onCancel || (() => {});

    confirmSaveModal.classList.add('is-visible');
    document.body.classList.add('modal-open');
    activateTrap(confirmSaveModal);
    
    // Använd 'transitionend' för robust fokus-sättning
    confirmSaveModal.addEventListener('transitionend', () => {
        if (confirmCancelBtn) confirmCancelBtn.focus();
    }, { once: true });
}

export function initializeConfirmSaveModal() {
    const { confirmSaveModal, confirmOverwriteBtn, confirmRenameBtn, confirmCancelBtn } = DOMElements;
        if (!confirmSaveModal) return;

    confirmOverwriteBtn.addEventListener('click', () => {
        hideModal();
        if (typeof currentOnOverwriteCallback === 'function') {
            currentOnOverwriteCallback();
        }
    });

    confirmRenameBtn.addEventListener('click', () => {
        // Notera: vi döljer inte denna modal än, eftersom den andra öppnas "ovanpå".
        // Denna logik kommer att förfinas med det nya modal-systemet.
        if (typeof currentOnRenameCallback === 'function') {
            currentOnRenameCallback();
        }
    });

    // Hantera Avbryt och klick på overlay
    confirmSaveModal.addEventListener('click', (e) => {
        if (e.target.closest('#confirmCancelBtn') || e.target === confirmSaveModal) {
            hideModal();
            if (typeof currentOnCancelCallback === 'function') {
                currentOnCancelCallback();
            }
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && confirmSaveModal.classList.contains('is-visible')) {
            hideModal();
            if (typeof currentOnCancelCallback === 'function') {
                currentOnCancelCallback();
            }
        }
    });
}